import { render, staticRenderFns } from "./popSetExpress.vue?vue&type=template&id=45f42f48"
import script from "./popSetExpress.vue?vue&type=script&lang=js"
export * from "./popSetExpress.vue?vue&type=script&lang=js"
import style0 from "./popSetExpress.vue?vue&type=style&index=0&id=45f42f48&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f42f48')) {
      api.createRecord('45f42f48', component.options)
    } else {
      api.reload('45f42f48', component.options)
    }
    module.hot.accept("./popSetExpress.vue?vue&type=template&id=45f42f48", function () {
      api.rerender('45f42f48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/saleOrder/components/popSetExpress/popSetExpress.vue"
export default component.exports